import { PlusCircleFillIcon } from '@chegg-ui/horizon-icons';
import React from 'react';
import { AddLinkButtonLabel, StyledAddLinkButton } from './styled';
export var AddLinkButton = function AddLinkButton(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement(StyledAddLinkButton, {
    onClick: onClick,
    "data-test": dataTest,
    className: "wf-add-link-button"
  }, /*#__PURE__*/React.createElement(PlusCircleFillIcon, {
    size: "xsmall"
  }), /*#__PURE__*/React.createElement(AddLinkButtonLabel, null, label));
};